import { tv } from "tailwind-variants";
import { Size } from "../helpers/helpers.js";

export const toggleButtonGroupStyle = tv({
  slots: {
    group: "inline-flex w-fit rounded-lg bg-muted p-1",
    button:
      "flex cursor-pointer items-center justify-center rounded-md text-muted-foreground transition-[background-color,color,box-shadow] hover:text-gray-700 focus:outline-hidden focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-inset disabled:cursor-not-allowed disabled:opacity-50 selected:bg-white selected:text-foreground selected:shadow-sm",
  },
  variants: {
    size: {
      [Size.SMALL]: {
        group: "rounded-md p-0.5",
        button: "rounded-sm selected:shadow-xs",
      },
      [Size.MEDIUM]: {
        group: "h-9",
      },
    },
    // Icon-only segments are square; small labeled segments size to their text.
    hasLabel: {
      true: {
        button: "flex-1 gap-1.5 px-3 font-medium whitespace-nowrap",
      },
    },
  },
  compoundVariants: [
    { size: Size.SMALL, hasLabel: false, class: { button: "size-6" } },
    { size: Size.MEDIUM, hasLabel: false, class: { button: "size-7" } },
    {
      size: Size.SMALL,
      hasLabel: true,
      class: { button: "flex-initial px-2.5 py-1 text-xs" },
    },
    { size: Size.MEDIUM, hasLabel: true, class: { button: "text-xs" } },
  ],
  defaultVariants: {
    size: Size.MEDIUM,
    hasLabel: false,
  },
});

/**
 * A chip-style multi-select toggle group: a wrapping row of bordered pills, each
 * independently selectable. Distinct from {@link toggleButtonGroupStyle}, which
 * is a compact segmented control (a single background pill of icon buttons). Use
 * this when each option carries a short text label — e.g. a weekday picker.
 *
 * Colors come from semantic tokens: `primary` resolves to indigo-600, so the
 * selected state matches the design mock's indigo chips without hard-coding a
 * palette color.
 */
export const toggleChipGroupStyle = tv({
  slots: {
    group: "flex flex-wrap gap-2",
    button:
      "cursor-pointer rounded-md border border-border-light bg-white px-3 py-1.5 text-sm text-muted-foreground transition-colors outline-none hover:border-border-strong hover:text-foreground focus-visible:ring-2 focus-visible:ring-primary disabled:cursor-not-allowed disabled:opacity-50 selected:border-primary selected:bg-primary/10 selected:font-medium selected:text-primary",
  },
});
